import {ReactNode} from 'react';
import {VerifiedPermissionsProvider} from '@flexinet/auth-components';
import permissions from '../config/permissions.ts';
import {useAuth} from '../hooks/useAuth.ts';

// FNP-1732: the console's own copy of this provider asked AVP before a session
// existed and let the 'idToken is required parameter' rejection escape. The
// shared provider waits for the session instead; this component only tells it
// what the console's AuthContext already knows. AVP is asked again when the
// signed-in user changes, not when the user's account record loads.
export const PermissionsProvider = (
    {
        actions,
        children,
    }: {
        actions: string[],
        children?: ReactNode,
    }) => {

    const {user, status} = useAuth();

    return (
        <VerifiedPermissionsProvider
            actions={actions}
            policyStoreId={permissions.policyStoreId}
            region={permissions.region}
            actionType='Action'
            enabled={permissions.enabled}
            sessionStatus={status}
            sessionKey={status === 'authenticated' ? user?.userId : undefined}
        >
            {children}
        </VerifiedPermissionsProvider>
    );
};
